import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const NameSummaryFormDE = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['name'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const firstNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'firstname'),
    message: s.dataSummary.requiredMessage!,
  });
  const firstNameLabel = translate(firstNameField?.label);

  const lastNameField = addReqiredMessage({
    field: s.name.fields.find(({ name }) => name === 'lastname'),
    message: s.dataSummary.requiredMessage!,
  });
  const lastNameLabel = translate(lastNameField?.label);

  const sexAtBirthField = s.name.fields.find(({ name }) => name === 'sexAtBirth');
  const sexAtBirthLabel = translate(sexAtBirthField?.label);
  const sexAtBirthValue =
    translate(sexAtBirthField?.options?.find(({ value }) => value === getFieldValue('sexAtBirth'))?.label)
    || getFieldValue('sexAtBirth');

  const genderIdentityField = s.name.fields.find(({ name }) => name === 'genderIdentity');
  const genderIdentityLabel = translate(genderIdentityField?.label);
  const genderIdentityValue =
    translate(genderIdentityField?.options?.find(({ value }) => value === getFieldValue('genderIdentity'))?.label) ||
    getFieldValue('genderIdentity');

  const titleField = s.name.fields.find(({ name }) => name === 'title');
  const titleLabel = translate(titleField?.label);
  const titleValue =
    translate(titleField?.options?.find(({ value }) => value === getFieldValue('title'))?.label) ||
    getFieldValue('title');

  return (
    <div className="summary-card" data-cy={'summary-form-name'}>
      <h2>{translate(s.dataSummary.titles?.name)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{titleLabel}</div>
        <div className={'value'}>
          {!editMode && titleValue}
          {editMode && <EditDataField slideId={'name'} field={titleField!} />}
        </div>
        <div className={'label'}>{sexAtBirthLabel}</div>
        <div className={'value'}>
          {!editMode && sexAtBirthValue}
          {editMode && (
            <EditDataField
              slideId={'name'}
              field={sexAtBirthField!}
            />
          )}
        </div>
        <div className={'label'}>{genderIdentityLabel}</div>
        <div className={'value'}>
          {!editMode && genderIdentityValue}
          {editMode && <EditDataField slideId={'name'} field={genderIdentityField!} />}
        </div>
        <div className={'label'}>{firstNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('firstname')}
          {editMode && <EditDataField slideId={'name'} field={firstNameField!} />}
        </div>
        <div className={'label'}>{lastNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('lastname')}
          {editMode && <EditDataField slideId={'name'} field={lastNameField!} />}
        </div>
      </div>
    </div>
  );
};